var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgChevronCollapse = function SvgChevronCollapse(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 10,
    "data-width-24": 14,
    viewBox: "0 0 13.6 17.1",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.235.186a.78.78 0 0 0-.48-.17.75.75 0 0 0-.48 1.33l6 5a.75.75 0 0 0 1 0l6-5a.766.766 0 0 0-1-1.16l-5.52 4.6zm11.07 16.702a.78.78 0 0 0 .48.17.75.75 0 0 0 .48-1.33l-6-5a.75.75 0 0 0-1 0l-6 5a.766.766 0 0 0 1 1.16l5.52-4.6z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChevronCollapse);
export default ForwardRef;